module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile@2x_576093.jpg";